/**
 * Enriches raw day items from generateStudyPlan with visual statuses
 * and full lesson entity data.
 *
 * @param {Array} dayItems - items from a day's `lessons` array
 * @param {Object} lessonEntities - Redux lesson entities keyed by id
 * @returns {Array} enriched items with `visualStatus` for lessons
 */
export default function enrichDayItems(dayItems, lessonEntities) {
  const enriched = [];
  let currentModule = null;
  let foundCurrent = false;

  for (const item of dayItems) {
    if (item.type === "module") {
      currentModule = item.name;
      enriched.push({ type: "module", name: item.name });
      continue;
    }

    if (item.type === "mock") {
      enriched.push({ type: "mock", mock: item, overBudget: !!item.overBudget });
      continue;
    }

    const entity = lessonEntities[item.id];
    const lesson = entity ? { ...item, ...entity } : item;

    let visualStatus;
    if (item.status === "completed") {
      visualStatus = "completed";
    } else if (!foundCurrent) {
      visualStatus = "current";
      foundCurrent = true;
    } else {
      visualStatus = "upcoming";
    }

    enriched.push({
      type: "lesson",
      lesson,
      visualStatus,
      moduleLabel: currentModule,
      overBudget: !!item.overBudget,
    });
  }

  return enriched;
}
